/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartMarqueePolygon = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 14v8h-8v-8zm-2 2h-4v4h4zm-8-1v2h-2v-2zm-4-4v2H6v-2zm14-1v2h-2v-2zM4 7v2H2V7zm18-1v2h-2V6zM9 5v2H7V5zm5-2v2h-2V3zm5-1v2h-2V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartMarqueePolygon as ChartMarqueePolygon };
